import { API } from "config/api";
import { API_ROUTES } from "config/apiRoutes";
import { downloadFile } from "utils/downloads";

function filenameFromContentDisposition(
  header: string | undefined,
  fallback: string
): string {
  if (!header) return fallback;
  const match = /filename="?([^"]+)"?/i.exec(header);
  return match?.[1] || fallback;
}

function fileBody(data: unknown): string {
  return typeof data === "string" ? data : JSON.stringify(data, null, 2);
}

/**
 * Downloads a single-student education-record JSON package (FERPA inspect).
 */
export async function downloadStudentEducationRecords(
  userId: string
): Promise<void> {
  const response = await API.get(
    API_ROUTES.USERS.EDUCATION_RECORDS_EXPORT(userId),
    { responseType: "text" }
  );
  const filename = filenameFromContentDisposition(
    response.headers["content-disposition"],
    `vetnebula-education-records-${userId}.json`
  );
  downloadFile(fileBody(response.data), filename, "application/json");
}

export type DisclosureParty = "parent" | "other_school" | "other";

/**
 * Releases a learner's records to a parent or another school and downloads
 * the copy only after the disclosure is recorded.
 */
export async function releaseStudentEducationRecords(
  userId: string,
  disclosure: { party: DisclosureParty; recipient: string; purpose: string }
): Promise<void> {
  const response = await API.post(
    API_ROUTES.USERS.EDUCATION_RECORDS_DISCLOSURE(userId),
    disclosure,
    { responseType: "text" }
  );
  const filename = filenameFromContentDisposition(
    response.headers["content-disposition"],
    `vetnebula-education-records-disclosure-${userId}.json`
  );
  downloadFile(fileBody(response.data), filename, "application/json");
}
